import { Observable } from "rxjs";
import {
    BRAND_WAREHOUSE_COMPLETE,
    BRAND_WAREHOUSE_CREATE,
    BRAND_WAREHOUSE_DELETE,
    BRAND_WAREHOUSE_DELETE_COMPLETE,
    BRAND_WAREHOUSE_UPDATE,
    BRAND_WAREHOUSE_UPDATE_COMPLETE,
} from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const createWarehouseEpic = (action$, store) => {
    return action$
        .ofType(BRAND_WAREHOUSE_CREATE)
        .map((action) => {
            return action.payload;
        })
        .concatMap(({ name }) => {
            return ajax({
                method: "POST",
                body: {
                    display_name: name,
                },
                url: `${siteConfig.api}/api/v3.0/warehouses`,
            })
                .map(({ response, status }) => {
                    response._id = response.id;
                    response.name = response.display_name;
                    if (response && status === 201) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: "Error saving warehouse" })),
                            {
                                payload: [],
                                error: true,
                                type: BRAND_WAREHOUSE_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_WAREHOUSE_COMPLETE,
                            },
                            snackbarAdd({ message: "Warehouse added" }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving warehouse");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit warehouses");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_WAREHOUSE_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage })),
                    );
                });
        });
};

export const updateWarehouseEpic = (action$, store) => {
    return action$
        .ofType(BRAND_WAREHOUSE_UPDATE)
        .map((action) => action.payload)
        .concatMap((warehouse) => {
            const { _id } = warehouse;
            warehouse.display_name = warehouse.name;
            delete warehouse._id;
            delete warehouse.id;
            delete warehouse.name;
            delete warehouse.brand_id;
            delete warehouse.created_on;
            delete warehouse.modified_on;
            return ajax({
                method: "PATCH",
                body: warehouse,
                url: `${siteConfig.api}/api/v3.0/warehouse/${_id}`,
            })
                .map(({ response, status }) => {
                    response._id = _id;
                    response.name = response.display_name;
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: "Error saving warehouse" })),
                            {
                                payload: [],
                                error: true,
                                type: BRAND_WAREHOUSE_UPDATE_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_WAREHOUSE_UPDATE_COMPLETE,
                            },
                            snackbarAdd({ message: "Warehouse updated" }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving warehouse");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit warehouses");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_WAREHOUSE_UPDATE_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage })),
                    );
                });
        });
};

export const deleteWarehouseEpic = (action$, store) => {
    return action$
        .ofType(BRAND_WAREHOUSE_DELETE)
        .map((action) => {
            return action.payload;
        })
        .concatMap((warehouseId) => {
            const brandUsers = store.getState().scope.brand.modules.base.user_connections;
            const assignedWarehouse = brandUsers.some((user) => {
                return (user.assigned_warehouses || []).some((warehouse) => {
                    return warehouse === warehouseId;
                });
            });

            if (assignedWarehouse) {
                // send a snackbar and dont move forward
                return [
                    store.dispatch(
                        snackbarAdd({
                            message: formatMessage(
                                "Warehouse cannot be deleted because it is currently assigned to a user.",
                            ),
                        }),
                    ),
                ];
            }

            return ajax({
                method: "DELETE",
                url: `${siteConfig.api}/api/v3.0/warehouse/${warehouseId}`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error deleting warehouse") })),
                            {
                                payload: [],
                                error: true,
                                type: BRAND_WAREHOUSE_DELETE_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_WAREHOUSE_DELETE_COMPLETE,
                            },
                            snackbarAdd({ message: "Warehouse deleted" }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error deleting warehouse");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit warehouses");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_WAREHOUSE_DELETE_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage })),
                    );
                });
        });
};
